import styled from 'styled-components';

const AccordionTitle = styled.text`
  font-size: 16px;
  font-weight: 100;
  color: #757575;
  text-align: left;
  padding-left: 8px;
  padding-right: 8px;
  vertical-align: middle;
  font-family: Nunito, sans-serif;
`;

const DropdownDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const DropdownStyle = styled.div`
  cursor: pointer;
  background-color: #fffff;
  border: 1px solid #797979;
  border-radius: 3px;
  box-sizing: border-box;
  color: #797979;
  line-height: normal;
  width: 100%;
  padding: 7px;
`;

const ButtonDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  fontsize: 18;
`;

const Row = styled.div`
  padding: 15px 10px 10px 0px;
  color: #797979;
`;

export { Row, DropdownDiv, AccordionTitle, DropdownStyle, ButtonDiv };
